import React, {useEffect, useState} from "react";
import banner from "../UserProfile/banner.jpg";
import '../UserProfile/index.css';
import reviewService from "../services/ReviewService";

// Displays the banner of the profile without Edit Profile button.
// Used to display on editProfile page and VisitingProfile page.
const EditProfileComponent = ({user}) => {

    const [reviewList, setReview] = useState([]);
    useEffect(() =>
                  reviewService.findAllUserReviews(user.userId).then(review => setReview(review)), [user.userId]);

    return(
        <>
            <div className="container">
                <div className="row pb-5">
                    <div>
                        <div className="wd-image-stack-item-bottom ">
                            <img src = {banner} alt="userBanner" className="img-fluid wd-banner-pic"/>
                        </div>
                        <div className="wd-image-stack-item-top m-0 mb-5">
                            <div className={"row"}>
                                <div className={" col-8 col-sm-8 col-md-9 col-lg-9 col-xl-10"}>
                                    {user.name}
                                    <div style={{fontSize: "large"}}>@{user.userId}</div>
                                </div>
                                <div className={"col"}>
                                    <div className={" d-none d-sm-none d-md-none d-md-none d-lg-block col-xl-block"} style={{fontSize: "xx-large"}}>
                                        <div>Reviews | {reviewList.length}</div>
                                    </div>
                                    <div className={" d-block d-sm-block d-md-block d-lg-none d-xl-none"} style={{fontSize: "x-large"}}>
                                        <div>Reviews | {reviewList.length}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EditProfileComponent;
